module.exports = __webpack_public_path__ + "send-twitter.1c5a90de.jpg";